import { clientePedido } from '../../apiClient/index'

function initialState () {
  return {
    mensajes: undefined,
    perfiles: undefined,
    usuarios: undefined
  }
}

const moduloApp = {
  namespaced: true,
  state: initialState,
  actions: {
    getMensajesInternacionalizados(context) 
    {
      clientePedido.get('/api/General/GetMensajesInternacionalizados')
      .then(response => {
        context.commit('setMensajes', response.data)
      })
    },

    updateRouterKey(context)
    {
      let newRouterKey = (new Date()).getTime()
      context.commit('setRouterKey', newRouterKey)
    },

    getUsuarios(context, payload) 
    {
      return new Promise((resolve) => {
        
        // verfico si los perfiles fueron inicializados...
        if(context.state.usuarios !== undefined)
        {
          resolve(context.state.usuarios)
        }
        else
        {
          // inicializo los usuarios
          clientePedido.get('/api/General/GetUsuarios', { params: payload })
          .then(response => context.commit('setUsuarios', response.data))
          .finally(() => resolve(context.state.usuarios))
        }
      })
    },

    getPerfiles(context, payload) 
    {
      return new Promise((resolve) => {
        
        // verfico si los perfiles fueron inicializados...
        if(context.state.perfiles !== undefined)
        {
          resolve(context.state.perfiles)
        }
        else
        {
          // inicializo los perfiles
          clientePedido.get('/api/General/GetPerfiles', { params: payload })
          .then(response => context.commit('setPerfiles', response.data))
          .finally(() => resolve(context.state.perfiles))
        }
      })
    },
  },
  mutations: {
    setMensajes(state, payload)
    {
      state.mensajes = payload
    },

    setRouterKey(state, payload) {
      state.routerKey = payload
    },

    setUsuarios(state, payload) {
      state.usuarios = payload
    },

    setPerfiles(state, payload) {
      state.perfiles = payload
    }
  }
}

export default moduloApp